module.exports = __webpack_public_path__ + "static/media/SWSCRC6-17.8196ded6.mp3";